import React from "react";

interface Homeprops {
  className?: string;
}

export const HeaderNavbar: React.FunctionComponent<Homeprops> = () => {
  return null;
}; 
export default HeaderNavbar; 